import "./src/styles/global.css"

// Debug: sprawdzenie czy gatsby-browser.js się wczytuje
console.log('🚀 gatsby-browser.js wczytany');

// Debug: sprawdzenie czy hydration następuje
export const onInitialClientRender = () => {
  console.log('🚀 onInitialClientRender: hydration complete');
}

// Matomo tracking dla SPA routing
export const onRouteUpdate = ({ location, prevLocation }) => {
  console.log('🚀 onRouteUpdate: navigating from', prevLocation?.pathname, 'to', location.pathname);
  if (typeof window !== 'undefined' && window._paq) {
    window._paq.push(['setCustomUrl', location.pathname + location.search]);
    window._paq.push(['setDocumentTitle', document.title]);
    window._paq.push(['trackPageView']);
  }
}
